/**
 * Route: /tags/:id — F031
 *
 * Tag-Detailseite mit zugeordneten Hotspots und Contacts.
 */
import { createFileRoute } from '@tanstack/react-router'
import { TagDetailPage } from '../features/tags/TagDetailPage'

export const Route = createFileRoute('/_auth/tags/$id')({
  component: TagDetailPage,
})